<template>
  <div class="review-card">
    <div class="review-header">
      <div class="review-rating">
        <div class="stars">
          <i 
            v-for="n in 5" 
            :key="n"
            :class="['fas', 'fa-star', { 'filled': n <= review.rating, 'empty': n > review.rating }]"
          ></i>
        </div>
        <span class="rating-number">{{ review.rating }}/5</span>
      </div>
      <div v-if="review.verified_booking" class="verified-badge">
        <i class="fas fa-check-circle"></i>
        <span>Verified</span>
      </div>
    </div>
    
    <div v-if="review.title" class="review-title">
      <h4>{{ review.title }}</h4>
    </div>
    
    <div class="review-content">
      <p>{{ review.comment }}</p>
    </div>
    
    <div class="review-footer">
      <div class="review-author">
        <span class="author-name">{{ review.author_name || 'Anonymous' }}</span>
        <span v-if="review.created_at" class="review-date">
          {{ formatDate(review.created_at) }}
        </span>
      </div>
      <div class="review-actions">
        <button @click="$emit('helpful', review.id)" class="helpful-btn">
          <i class="fas fa-thumbs-up"></i>
          <span>Helpful ({{ review.helpful_count || 0 }})</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReviewCard',
  props: {
    review: {
      type: Object,
      required: true
    }
  },
  emits: ['helpful'],
  methods: {
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', { 
        year: 'numeric', 
        month: 'short', 
        day: 'numeric' 
      });
    }
  }
};
</script>

<style scoped>
.review-card {
  background-color: white;
  border: 1px solid var(--cs-d-border);
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 16px;
}

.review-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  flex-wrap: wrap;
  gap: 12px;
}

.review-rating {
  display: flex;
  align-items: center;
  gap: 12px;
}

.stars {
  display: flex;
  gap: 2px;
}

.stars i {
  font-size: 16px;
}

.stars i.filled {
  color: #fbbc05;
}

.stars i.empty {
  color: #dadce0;
}

.rating-number {
  font-size: 14px;
  font-weight: 500;
  color: var(--cs-d-muted);
}

.verified-badge {
  display: flex;
  align-items: center;
  gap: 4px;
  background-color: var(--cs-d-success-bg);
  color: var(--cs-d-success);
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.verified-badge i {
  font-size: 12px;
}

.review-title {
  margin-bottom: 12px;
}

.review-title h4 {
  margin: 0;
  font-size: 18px;
  color: var(--cs-d-text);
}

.review-content {
  margin-bottom: 16px;
  color: var(--cs-d-muted);
  line-height: 1.6;
}

.review-content p {
  margin: 0;
}

.review-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 16px;
  border-top: 1px solid var(--cs-d-divider);
  flex-wrap: wrap;
  gap: 12px;
}

.review-author {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.author-name {
  font-weight: 500;
  color: var(--cs-d-text);
  font-size: 14px;
}

.review-date {
  font-size: 12px;
  color: var(--cs-d-muted);
}

.review-actions {
  display: flex;
  gap: 8px;
}

.helpful-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  background-color: var(--cs-d-surface-alt);
  border: 1px solid var(--cs-d-border);
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 14px;
  color: var(--cs-d-muted);
  cursor: pointer;
  transition: all 0.2s;
}

.helpful-btn:hover {
  background-color: var(--cs-d-tint);
  border-color: var(--cs-d-link);
  color: var(--cs-d-link);
}

.helpful-btn i {
  font-size: 14px;
}

@media (max-width: 768px) {
  .review-footer {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>

